<!--
  This work has been created or enhanced by
    Markus Luckey, 2025, KERNBLICK GmbH

  This file is covered by the EU PL 1.2 license.
  You may obtain a copy of the licence at
  https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
-->

<template>
  <div class="apps">
    <div class="iframe-parent">
      <iframe
        v-for="app in apps"
        v-show="app.id == $route.params.id"
        :key="app.id"
        :ref="app.id"
        class="iframe"
        :src="visited[app.id] || (app.id == $route.params.id) ? app.url : ''"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Apps',
  props: {
    apps: { type: Array, default: () => [] }
  },
  data() {
    return {
      visited: {},
    };
  },
  watch: {
    '$route.params.id': function (id) {
      this.visited[id] = true;
    },
  },
  created() {
    this.visited[this.$route.params.id] = true;
  }
};
</script>

<style lang="css" scoped>
  .apps {
    height: 98%;
  }
  .iframe-parent {
    height: 100%;
    position: absolut;
    top: 50px;
    width: 100%;
    left: 0;
  }
  .iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
</style>
